const darkPalette = {
  mode: "dark",
  common: {
    black: "#10111E",
    white: "#fff",
    green: "#58B84A",
    page: "#18191F",
    headerbg: "#2C3345",
    errorbg: "#FDE0E0",
    errortext: "#683333",
    warningbg: "#FCEDD8",
    inputs: "#E6EAF5",
    red: "#FF6C6C",
  },
  primary: {
    main: "#F29B2A",
    dark: "#C87F1A",
    darker: "#070812",
    lightdark: "#10111E",
  },
  secondary: {
    main: "#6B8EAC",
    text: "#ABC6D1",
    light: "#ECF7FF",
    lightest: "#2C3345",
  },
  background: {
    default: "#10111E",
    paper: "#1e1f2a",
    cardGradient: "linear-gradient(145deg, #141625, #272939)",
    inputGradient: "linear-gradient(to bottom,#C1C8DB, #7e828a)",
    inputGradientIcon: "#abb0bf",
    treeGradient: "linear-gradient(to bottom,#272939, #151727)",
  },
};

const lightPalette = {
  mode: "light",
  common: {
    black: "#10111E",
    white: "#fff",
    green: "#58B84A",
    page: "#18191F",
  },
  primary: {
    main: "#F29B2A",
    dark: "#C87F1A",
  },
  secondary: {
    main: "#6B8EAC",
  },
  background: {
    default: "#10111E",
    paper: "#1e1f2a",
    cardGradient: "linear-gradient(145deg, #1e1f2a, #11121a)",
  },
};

export { darkPalette, lightPalette };
